var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInfo01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 13.556,
  height: 13.778,
  fill: "#FCF0EA",
  rx: 6.778
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6024",
  d: "M6 3h1.556v5.444H6zM6 9.222h1.556v1.556H6z"
})));
export default SvgIconInfo01;